class CustomLocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[name="locale_code"], input[name="country_code"]');
    this.select = this.querySelector('select');

    this.select.addEventListener('change', this.onItemClick.bind(this));
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.input.value = event.currentTarget.value;
    if (form) form.submit();
  }

  normalizeString(str) {
    return str
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .toLowerCase();
  }
}

if (!customElements.get('custom-localization-form')) {
  customElements.define('custom-localization-form', CustomLocalizationForm);
}
